module.exports = __webpack_public_path__ + "static/media/earthquake-navy-blue.1ae9b63c.svg";